import type { QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteriaParams } from '@/shared/model';
import { toId } from './values';

export function countries(query: QueryObject): Pick<SearchCriteriaParams, 'countries'> | null {
  const id = toId(query.toCountry);

  return id === null ? null : { countries: [id] };
}
